import { Typo3Section } from '@/types/typo3'
import { Container, Richtext, Section, Title } from '@/ui/components'
import { memo } from 'react'

interface Props {
  title: string
  text: string
  section: Typo3Section
}

const SectionIntro = ({ title, text, section }: Props) => (
  <Section data={section} className="s-section-intro py-4xl">
    <Container className="gap-md flex flex-col items-center">
      <Title as="h2" className="h2 text-accent-300 max-w-[49rem] text-center">
        {title}
      </Title>
      <Richtext
        text={text}
        className="text-medium-regular max-w-[33rem] text-center"
      />
    </Container>
  </Section>
)

SectionIntro.displayName = 'SectionIntro'

export default memo(SectionIntro)
